import React, { useState } from 'react'
import Wysiwyg from '../../../elements/form/Wysiwyg'
import { useDispatch, useSelector } from 'react-redux';
import ModalActionButton from '../../../elements/ModalActionButton';
import { createApplicationResponse } from '../../../../store/actions/applicationResponsesActions';
import { sanitizePayload } from '../../../../utils';

const NewApplicationResponse = ({description, closeFunction, reload, application}) => {
    const responsesSelector = useSelector(state => state.applicationResponses)
    const dispatch = useDispatch()

    const [responseMessage, setResponseMessage] = useState('');

    const pushResponse = () => {
        const payload = {
            response: responseMessage
        }
        dispatch(createApplicationResponse(application._id, sanitizePayload(payload)))
    }

    return (
        <div>
            <div className='mb-4 text-sm'>{description}</div>

            <div className='w-full'>
                <div className='borderless px-6 long-text'>
                    <Wysiwyg 
                        fieldTitle=""
                        initialValue={''}
                        updateValue={(value)=>{setResponseMessage(value)}}
                    />
                </div>
            </div>

            <div className="mt-8 flex flex-row-reverse gap-x-4">
                <ModalActionButton
                    buttonLabel={`Respond to application`}
                    buttonAction={()=>{pushResponse()}}
                    processing={responsesSelector.creatingResponse}
                 />

                <button
                    type="button"
                    className="inline-flex justify-center px-5 py-4 text-xs font-medium bg-transparent border border-transparent rounded-md hover:bg-opacity-50 hover:bg-secondary focus:outline-none"
                    onClick={closeFunction}
                >
                    Cancel
                </button>
                
            </div>
        </div>
    )
}

export default NewApplicationResponse